/**
 * Mekanics Manager — Vocabulario de íconos (RemixIcon)
 * -----------------------------------------------------
 * Estándar de la app: estilo `-line` por defecto; usar `-fill`
 * únicamente para el estado ACTIVO en la navegación.
 *
 * Tamaños sugeridos: 20px en menús, 24px en headers.
 * Siempre acompañar de texto accesible y marcar el <i> con
 * aria-hidden="true".
 */

/** Mapa canónico módulo → ícono (versión `-line`). */
export const ICONS = {
  dashboard: 'ri-dashboard-line',
  ordenesServicio: 'ri-tools-line',
  citas: 'ri-calendar-schedule-line',
  vehiculos: 'ri-car-line',
  clientes: 'ri-user-3-line',
  inventario: 'ri-archive-2-line',
  stockBajo: 'ri-alert-line',
  ventas: 'ri-cash-line',
  reportes: 'ri-bar-chart-2-line',
  kpis: 'ri-line-chart-line',
  configuracion: 'ri-settings-3-line',
  equipo: 'ri-team-line',
  facturacion: 'ri-bill-line',
} as const;

export type IconKey = keyof typeof ICONS;

/** Devuelve la variante `-fill` de un ícono `-line` (estado activo). */
export function toFill(icon: string): string {
  return icon.endsWith('-line') ? icon.slice(0, -5) + '-fill' : icon;
}

/** Atajo: ícono activo (`-fill`) o inactivo (`-line`) según bandera. */
export function navIcon(icon: string, active: boolean): string {
  return active ? toFill(icon) : icon;
}
